import { useMemo } from 'react';
import { useAppSelector, useGameConfigurationSelector, useUserSelector } from 'js/store/hooks';
import { map, prop, propOr, pipe, uniq, unnest, flatten, pick } from 'ramda';

export const useAvailableGames = () => {
    const { games } = useGameConfigurationSelector(pick(['games']));
    const { dynamicTags, oldGamesFeeds } = useAppSelector(pick(['dynamicTags', 'oldGamesFeeds']));
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const usedFeed = dynamicTags && dynamicTags.DTAG_USEFEEDS?.split(',');

    if (!usedFeed) {
        return;
    }

    const getFeedConfig = oldGamesFeeds?.filter(el => usedFeed.includes(el.name));
    const res = getFeedConfig.reduce((acc, curr) => {
        acc.push(curr.categories);
        return acc;
    }, []);

    const categories = flatten(res);
    const gameCodes = useMemo(
        () => pipe(
            map(propOr([], 'gameCodes')),
            unnest,
            uniq
        )(categories),
        [categories]
    );

    return useMemo(() => {

        const result = gameCodes.map((code) => {
            if (!games[code]) {
                return null;
            }

            const { name, images = {} } = games[code];

            return {
                code,
                name,
                image: !isLoggedIn && images.guest || images.base
            };
        });

        return result.filter(el => el);
    }, [gameCodes, games, isLoggedIn]);
};
